import React from "react";

const AirdeskIconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24.776 27.177"
    >
      <g transform="translate(-397.096 -182.096)">
        <g transform="translate(397.096 182.096)">
          <path
            id="Path_3394"
            opacity="0.5"
            fill="#fff"
            d="M461.18,218.47a.74.74,0,0,0-.732-.47H455.98a.644.644,0,0,0-.653.47l-4.73,13.144a.6.6,0,0,0,.444.784c1.49.235,2.979.392,4.521.5a.566.566,0,0,0,.575-.392l2.143-6.533,2.143,6.533a.55.55,0,0,0,.6.392,41.722,41.722,0,0,0,4.469-.5.571.571,0,0,0,.444-.784Z"
            transform="translate(-445.863 -218)"
          />
          <path
            fill="#fff"
            d="M457.365,279.483a.568.568,0,0,0-.732-.549,46.342,46.342,0,0,1-23.31,0,.58.58,0,0,0-.732.549v3.946a.612.612,0,0,0,.444.575c.5.1.993.235,1.49.34l-1.882,5.174c-.157.392.026.653.47.653h5.044a.593.593,0,0,0,.653-.47l1.49-4.521c1.542.131,3.11.209,4.678.209s3.136-.078,4.678-.209l1.463,4.521a.617.617,0,0,0,.653.47h5.043c.418,0,.627-.261.47-.653l-1.882-5.174c.5-.1.993-.209,1.49-.34a.567.567,0,0,0,.444-.575v-3.946Z"
            transform="translate(-432.589 -262.994)"
          />
        </g>
      </g>
    </svg>
  );
};

export default AirdeskIconSvg;
